export { default as NegExecutionFragment } from "./NegExecution.fragment";
